@use '../../scss/utility';
@use './hint360/hint360';

:host {
  display: block;
  position: relative;
  cursor: ew-resize;

  &:focus {
    outline: utility.wb-pixel-to-rem(1px) solid var(--wb-blue-45);
    outline-offset: utility.wb-pixel-to-rem(1px);
  }

  &:not(:focus):focus-within {
    outline: none;
  }

  .image {
    position: absolute;
    pointer-events: none;
    -webkit-user-drag: none;
    inset: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;
  }

  .overlay {
    position: absolute;
    inset: 0;
  }
}

:host([ratio='1x1']) {
  aspect-ratio: 1 / 1;
}

:host([ratio='3x2']) {
  aspect-ratio: 3 / 2;
}

:host([ratio='16x9']) {
  aspect-ratio: 16 / 9;
}

:host([ratio='2x1']) {
  aspect-ratio: 2 / 1;
}

:host([ratio='4x1']) {
  aspect-ratio: 4 / 1;
}

:host([ratio='4x3']) {
  aspect-ratio: 4 / 3;
}

:host([ratio='3x4']) {
  aspect-ratio: 3 / 4;
}

:host([ratio='12x5']) {
  aspect-ratio: 12 / 5;
}

:host([ratio='9x4']) {
  aspect-ratio: 9 / 4;
}
